module.exports = __webpack_public_path__ + "static/media/ic-arrow-right.4dea553c.svg";